import { colors } from '../../colors';
var anchor = {
  anchorColor: colors.nvaTeal
};
export default anchor;